// ─────────────────────────────────────────────────────────────────────────────
// Report registry + role gate for SurvAIHealth Metrics & Reporting.
//
// reportKey (from metricsNav.js) → report component. The router in MetricsApp
// looks reports up here; an unknown key falls through to a graceful panel.
// ─────────────────────────────────────────────────────────────────────────────

import GrievanceDashboard from "./reports/GrievanceDashboard";
import GrievanceList from "./reports/GrievanceList";
import GrievanceOverview from "./reports/GrievanceOverview";
import GrievanceSummaries from "./reports/GrievanceSummaries";
import GrievancesByDaysToClose from "./reports/GrievancesByDaysToClose";
import OpenByCategory from "./reports/OpenByCategory";
import OpenByDepartment from "./reports/OpenByDepartment";
import GrievanceKeywordSearch from "./reports/GrievanceKeywordSearch";
import EmployeesMentioned from "./reports/EmployeesMentioned";

export const REPORT_COMPONENTS = {
  GrievanceDashboard,
  GrievanceList,
  GrievanceOverview,
  GrievanceSummaries,
  GrievancesByDaysToClose,
  OpenByCategory,
  OpenByDepartment,
  GrievanceKeywordSearch,
  EmployeesMentioned,
};

// Metrics & Reporting is now available to all facilities (was admin/vp only).
// Note: this surfaces the top app-switcher (Compliance Suite | Metrics & Reporting)
// for every signed-in user. The EHR remains separately gated (canViewEHR).
export function canViewMetrics(session) {
  return !!session;
}
